exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.must .el-form-item__label:before{\n\tcontent: '*';\n\tcolor: #F56C6C;\n\tmargin-right: 4px;\n}\n", ""]);

// exports
